import { LockOutlined } from '@ant-design/icons';
import { ArrowUpOutlined } from '@ant-design/icons';
import { Alert, BackTop, Breadcrumb, Button, Layout, Modal, Result } from 'antd';
/*

Default Layout - Wraps sections with nav, footer etc

*/

import React from "react";
import { useHistory, useLocation } from "react-router-dom";

import Nav from "../components/Nav";
import { navigation } from "../data.js";
import { useSession } from "../utils/Session";
import { ucfirst } from "../utils/Utils";

export default function Default(props) {

    const { drawDarkMode = () => { } } = props;

    const loc = useLocation();
    const history = useHistory();
    const [session, setSession] = useSession();

    const hasBanner = (window?.sitesettings?.banner_message?.text) ? true : false;

    const checkPermission = () => {
        let has_permission = true;
        Object.keys(navigation).forEach(menu => {
            let { subnav = [] } = navigation[menu];
            subnav.forEach(item => {
                if (item.hasOwnProperty("permission")) {
                    if (loc.pathname.includes(item.slug)) {
                        if (session.hasOwnProperty(item.permission)) {
                            if (!session[item.permission]) has_permission = false;
                        }
                        if (session.permissions.hasOwnProperty(item.permission)) {
                            if (!session.permissions[item.permission]) has_permission = false;
                        }
                    }
                }
            })
        })
        return has_permission;
    }

    const drawPath = (_p) => {
        if (_p.includes("/filter")) {
            // cull filters from breadcrumbs
            _p = _p.split("/filter")[0];
        }
        let items = _p.split("/");
        let title = "";
        items.forEach((element, index) => {
            if (index === 1) {
                if (element === "my-company-catalogues") {
                    title += title += "My Company's Catalogues > ";
                } else {
                    title += ucfirst(element) + " > ";
                }
            } else {
                if (element === "my-company-catalogues") {
                    title += "My Company's Catalogues";
                } else {
                    title += ucfirst(element) + " ";
                }

            }
        });
        document.title = title;
        return items.map((itm, ind) => {
            let breadcrumb_item = itm;
            if (itm === "my-company-catalogues") {
                breadcrumb_item = "My Company's Catalogues"
            }
            if (itm === "") {
                return <Breadcrumb.Item key={ind}></Breadcrumb.Item>
            } else {
                return <Breadcrumb.Item key={ind}>{ucfirst(breadcrumb_item)}</Breadcrumb.Item>
            }
        })
    }

    const drawNoPermission = () => {
        return (
            <>
                <Result
                    icon={<LockOutlined />}
                    title="Sorry, you are not authorized to access this page."
                    extra={
                        <Button onClick={() => history.push("/")} type="primary" key="console">
                            Home
                        </Button>
                    }
                />
            </>
        )
    }


    const drawMessage = () => {

        if (window?.sitesettings?.banner_message?.text) {

            let { type = "success", link = "", text = "" } = window.sitesettings.banner_message;

            let _color = "#f00";
            let _txt = "#fff";
            switch (type) {
                case "warning":
                    _color = "#ffa200";
                    _txt = "#000";
                    break;
                case "error":
                    _color = "#e00000";
                    break;
                case "info":
                    _color = "#1465c8";
                    break;
                default:
                    _color = "#2eb000";
                    break;
            }



            return (
                <Alert
                    onClick={() => { if (link) { window.open(link) } }}
                    className="switchbanner"
                    message={<div style={{ "textAlign": "center" }}>
                        <small style={{ "color": _txt }}>{text}</small>
                    </div>}
                    banner
                    style={{ "cursor": (link) ? "pointer" : "default", "color": "#fff", "backgroundColor": _color, "borderLeft": "0px", "borderRight": "0px", "position": "fixed", "zIndex": "1000", "height": "30px", "width": "100%" }}
                    showIcon={false}

                    type={type}
                />
            )
        } else {

            
            return (
                <>
                    <Alert
                        className="switchbanner"
                        message={<div style={{ "textAlign": "center" }}>
                            <small>Having trouble? <a onClick={() => window.open("https://bookmanager.com/tbm/?q=h")}>Click here</a> to return to the old "admin" site. (Just a head's up that the old site will be retired Fall 2025.)</small>
                        </div>}
                        banner
                        style={{ "borderLeft": "0px", "borderRight": "0px", "position": "fixed", "zIndex": "1000", "height": "30px", "width": "100%" }}
                        showIcon={false}
                        type="success"
                    />
                </>
            )
        }




    }

    const drawWorkingWith = () => {
        if (session.hasOwnProperty("stores_working_with") && Array.isArray(session.stores_working_with) && session.stores_working_with.length > 0) {
            let _name = session.stores_working_with[0].name;
            let _more = false;
            if (session.stores_working_with.length > 1) {
                _more = session.stores_working_with.length - 1
            }
            return (<div style={{"color" : "#888", "marginTop" : "2px"}}><nobr><small><em>Viewing <strong>{_name}</strong> {(_more && <> + {_more} more</>)}&nbsp;</em></small></nobr></div>)
        } else {
            return (<></>);
        }
    }

    return (
        <>
            {drawDarkMode()}
            <BackTop style={{ "bottom": "88px" }}>
                <Button type="primary" ghost shape="circle" icon={<ArrowUpOutlined />} size="large" />
            </BackTop>
            {(hasBanner && <>{drawMessage()}</>)}


             <div className="navWrapper" style={{top : (hasBanner) ? "30px" : "0px"}}>
                <div style={{ "width": "1240px", "margin": "0 auto" }}>
                    <Nav dark={props.dark} />
                </div>
            </div>
             <div style={{ "height": (hasBanner) ? "85px" : "55px", "display": "block" }} />
            <Layout>
                <Layout.Content>
                    <div style={{ "height": "calc(100vh - 85px)", "minWidth": "1310px", "maxWidth": "1310px", "margin": "0 auto", "padding": "0 35px" }}>
                        <div className="shim" /><div className="shim" />

                        <div className="float-flex">
                            <Breadcrumb style={{ "fontSize": "12px", "fontWeight": "500", "padding": "5px 15px" }}>
                                {drawPath(loc.pathname)}
                            </Breadcrumb>
                            {drawWorkingWith()}
                        </div>
                        <div className="shim" /><div className="shim" />
                        <div className={(props.noborder) ? "" : "layoutWrapper"} style={{ "marginBottom": "20px" }}>
                            {(checkPermission()) ? props.children : drawNoPermission()}
                        </div>
                        <div style={{ "fontSize": "12px", "fontWeight": "500", "padding": "5px 15px" }}></div>
                    </div>
                </Layout.Content>
            </Layout>
        </>
    );
}